module.exports = require(10).EventEmitter;
